// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1>Edit Payment Schedule</h1>
        </div>
        <div class="hoa-dialog__main">
            <p>Edit payment dates and amounts to update your payment schedule.</p>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button tid="editPaymentDialogClose"
                    id="editPaymentDialogClose"
                    class="Button Button--blue Button--minWidth130"
                    (click)="closeThisDialog(0)">
                Close
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;